/**
 * Puts the size selector above the Drip Apps "Build your own Gang Sheet" button,
 * matching the reference site.
 *
 * Kalles renders the variant picker (.variations) inside the product form, while
 * the app block is a sibling block outside it, so the two cannot be interleaved
 * with CSS alone. Rather than move .variations out of the form, which would stop
 * its inputs submitting, this moves the app block into the form directly after
 * the picker. Nothing leaves the form, so add to cart is unaffected.
 *
 * Ordering of the remaining form children is done in CSS, see line_items-dtf.
 */
(function () {
  'use strict';

  var MAX_TRIES = 40;      // the app block is injected asynchronously
  var INTERVAL = 250;

  function place() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return false;

    var variations = form.querySelector('.variations');
    var app = document.querySelector('.shopify-app-block');
    if (!variations || !app) return false;

    // already positioned
    if (app.parentElement === variations.parentElement &&
        app.previousElementSibling === variations) return true;

    variations.insertAdjacentElement('afterend', app);
    app.classList.add('dtf-builder-cta');
    form.classList.add('dtf-builder-form');
    return true;
  }

  function start() {
    if (place()) return;
    var tries = 0;
    var t = setInterval(function () {
      if (place() || ++tries >= MAX_TRIES) clearInterval(t);
    }, INTERVAL);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
